import React from 'react';
import styled from 'styled-components';

export interface SimpleItem {
  label: string;
  value: string;
}

interface SimpleInfoTableProps {
  items: SimpleItem[];
}

const SimpleInfoTable: React.FC<SimpleInfoTableProps> = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <TableWrapper>
      {items.map((item, idx) => (
        <Row key={idx}>
          <Label>{item.label}</Label>
          <Value>{item.value}</Value>
        </Row>
      ))}
    </TableWrapper>
  );
};

export default SimpleInfoTable;

const TableWrapper = styled.div`
  width: 100%;
`;

const Row = styled.div`
  padding: 12px;
  gap: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.div`
  flex: 1;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: -2%;
  color: #787d87;
`;

const Value = styled.div`
  flex: 2;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -2%;
  color: #424854;
  word-break: keep-all;
`;
